import { atom } from 'jotai';

export const isSidebarFilterOpenState = atom<boolean>(false);
